import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  EmailSettingsParams,
  USER_EMAIL_SETTINGS_KEY,
  UpdateEmailSettingResponse,
  updateEmailSettings,
} from '../utils/backend-api/settings';

export default function useUpdateEmailSettings() {
  const queryClient = useQueryClient();
  const { mutate, data, isLoading, isError } = useMutation(
    (params: EmailSettingsParams) => updateEmailSettings(params),
    {
      onSuccess: (data: UpdateEmailSettingResponse) => {
        toast.success(data.message);
        queryClient.invalidateQueries(USER_EMAIL_SETTINGS_KEY);
      },
      onError: (data: [string]) => {
        toast.error(data.join(';'));
      },
    }
  );
  return { mutate, data, isLoading, isError };
}
